import { useEffect, useRef } from 'react';

interface Props {
  handleGeneratePredefinedDataModalOpen: () => void;
  predefinedReportGeneration: boolean;
  loading: boolean;
}

export const useGenerateReportFromPredefinedData = ({
  handleGeneratePredefinedDataModalOpen,
  predefinedReportGeneration,
  loading
}: Props) => {
  const initOpen = useRef<boolean>(false);

  useEffect(() => {
    if (predefinedReportGeneration && !loading && !initOpen.current) {
      handleGeneratePredefinedDataModalOpen();
      initOpen.current = true;
    }
  }, [handleGeneratePredefinedDataModalOpen, loading, predefinedReportGeneration]);
};
